
export enum TVSystem {
  SAMSUNG = 'SAMSUNG',
  LG = 'LG',
  VIRGIN_MEDIA = "VIRGIN_MEDIA",
  TIVO = "TIVO",
  VESTEL = "VESTEL",
  OTHER = "OTHER"
}